export default __webpack_public_path__ + "static/media/reboot.3b9eca10.png";